export const STATUSES_ALLOW_REFUND: string[] = [
  'mierror',
  'invalid',
  'invalid_offer',
  'expired',
  'cancelled',
  'declined',
  'errored',
];

export const STATUSES_ERROR: string[] = ['nomatch', 'botban', 'rehosted'];
